/**
 * A Worker that can be run on a different origin by respecting CORS
 * By default, a Worker constructor that uses an url as its parameters ignores CORS
 * and fails on a different origin.
 * This way we can run web worker on scripts served by a CDN
 */
export class CorsWorker {
  private worker: Worker;

  /**
   * @param {string | URL} url - worker script URL
   * @param {WorkerOptions} [options] - worker options
   */
  constructor(url, options) {
    const absoluteUrl = new URL(url, window.location.href).toString();
    const workerSource = `\
  const urlString = ${JSON.stringify(absoluteUrl)}
  const originURL = new URL(urlString)
  const isValidUrl = (urlString) => { 
    try { return Boolean(new URL(urlString, originURL)) } catch(e){ return false }  
    }

  const originalImportScripts = self.importScripts
  self.importScripts = (url) => {
    if(!url.toString().includes('variable-rate')) {
      const lastSlashIndex = urlString.lastIndexOf('/');
      const base = urlString.slice(0, lastSlashIndex + 1);

      const idx = url.indexOf('.com/');
      const suffix = idx !== -1 ? url.substring(idx + 5) : '';

      const mergedUrl = base + suffix;
      url = mergedUrl;
    }
    originalImportScripts.call(self, new URL(url.toString(), originURL).toString())
      
  }
  importScripts(urlString);
`;
    const blob = new Blob([workerSource], { type: 'application/javascript' });
    const objectURL = URL.createObjectURL(blob);
    this.worker = new Worker(objectURL, options);
    URL.revokeObjectURL(objectURL);
  }

  getWorker() {
    return this.worker;
  }
}
